import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import * as pipelineModel from '../../../../features/pipeline/pipeline-model.ts';

import {
	getCustomChannelsForBlendMode,
	getSelectableBlendOpsForChannel
} from '../../../../features/step/step-blend-strategies.ts';

import { BLEND_MODES } from '../../../../features/step/step-model.ts';
import StepHeader from './svelte-step-header.svelte';
import StepPreview from './svelte-step-preview.svelte';

var root = $.from_html(`<option> </option>`);
var root_1 = $.from_html(`<div class="lut-thumb-crosshair svelte-j81rnd" aria-hidden="true"></div>`);
var root_2 = $.from_html(`<label data-part="op-item" class="svelte-j81rnd"><span data-part="op-label" class="svelte-j81rnd"> </span> <select class="control-select svelte-j81rnd"></select></label>`);
var root_3 = $.from_html(`<div data-part="op-grid" class="svelte-j81rnd"></div>`);
var root_4 = $.from_html(`<article data-step-item="true" class="svelte-j81rnd"><!> <aside data-part="step-socket-rail" class="svelte-j81rnd"><button type="button" class="step-socket svelte-j81rnd" data-step-socket="true" data-axis="x"><span data-part="socket-dot" aria-hidden="true" class="svelte-j81rnd"></span> <span data-part="step-socket-axis-label" class="svelte-j81rnd">X</span> <span data-part="step-socket-param" class="svelte-j81rnd"> </span></button> <button type="button" class="step-socket svelte-j81rnd" data-step-socket="true" data-axis="y"><span data-part="socket-dot" aria-hidden="true" class="svelte-j81rnd"></span> <span data-part="step-socket-axis-label" class="svelte-j81rnd">Y</span> <span data-part="step-socket-param" class="svelte-j81rnd"> </span></button></aside> <section data-part="step-core" class="svelte-j81rnd"><div data-part="lut-row" class="svelte-j81rnd"><label data-part="lut-select-field" class="svelte-j81rnd"><span data-part="lut-select-label" class="svelte-j81rnd"> </span> <select class="control-select svelte-j81rnd"></select></label> <div data-part="lut-thumb-wrap" class="svelte-j81rnd"><img class="checker-bg svelte-j81rnd" data-part="lut-thumb" alt="LUT thumbnail"/> <!></div></div> <div><label data-part="step-mode-field" class="svelte-j81rnd"><span data-part="op-label" class="svelte-j81rnd"> </span> <select class="control-select svelte-j81rnd"></select></label></div> <!></section> <!></article>`);

const $$css = {
	hash: 'svelte-j81rnd',
	code: 'article[data-step-item="true"].svelte-j81rnd {display:grid;grid-template-rows:auto auto;grid-template-columns:10ch minmax(0, 1fr) 120px;gap:10px;border:1px solid var(--color-line);border-radius:12px;padding:8px;background:color-mix(in srgb, var(--color-panel-2), var(--color-bg) 5%);}article[data-step-item="true"][data-muted="true"].svelte-j81rnd {border-color:color-mix(in srgb, var(--color-line), var(--color-warn) 22%);background:color-mix(in srgb, var(--color-panel-2), var(--color-warn) 4%);}[data-part="step-socket-rail"].svelte-j81rnd {display:flex;flex-direction:column;justify-content:center;gap:8px;}.step-socket.svelte-j81rnd {position:relative;text-align:left;min-height:58px;padding:8px 8px 8px 26px;font-size:11px;line-height:1.2;white-space:normal;overflow-wrap:anywhere;display:flex;flex-direction:column;justify-content:center;gap:4px;border:1px solid var(--color-line);border-radius:10px;background:color-mix(in srgb, var(--color-panel), var(--color-bg) 10%);}.step-socket.svelte-j81rnd [data-part="socket-dot"]:where(.svelte-j81rnd) {position:absolute;top:50%;left:8px;width:10px;height:10px;border-radius:50%;border:2px solid var(--color-socket-border);background:var(--color-socket-bg);transform:translateY(-50%);pointer-events:none;}[data-part="step-socket-axis-label"].svelte-j81rnd {font-size:10px;font-weight:700;letter-spacing:0.08em;color:var(--color-step-socket-axis);}[data-part="step-socket-param"].svelte-j81rnd {font-size:10px;color:var(--color-text);}[data-part="step-core"].svelte-j81rnd {min-width:0;border:1px solid var(--color-panel-border-strong);border-radius:10px;padding:8px;background:color-mix(in srgb, var(--color-panel), var(--color-bg) 8%);}[data-part="lut-row"].svelte-j81rnd {display:grid;grid-template-columns:minmax(0, 1fr) 72px;gap:8px;margin-bottom:8px;align-items:center;}[data-part="lut-select-field"].svelte-j81rnd,\n  [data-part="step-mode-field"].svelte-j81rnd {display:flex;flex-direction:column;gap:3px;}[data-part="lut-select-label"].svelte-j81rnd,\n  [data-part="op-label"].svelte-j81rnd {font-size:10px;color:var(--color-muted);}.control-select.svelte-j81rnd {width:100%;border:1px solid var(--color-control-border);border-radius:8px;background:var(--color-control-bg);color:var(--color-text);font-size:12px;padding:6px 8px;}[data-part="lut-thumb-wrap"].svelte-j81rnd {position:relative;width:72px;height:72px;flex-shrink:0;overflow:hidden;border-radius:8px;}.checker-bg.svelte-j81rnd {background-color:var(--color-checker-a);background-image:linear-gradient(45deg, var(--color-checker-b) 25%, transparent 25%, transparent 75%, var(--color-checker-b) 75%),\n      linear-gradient(45deg, var(--color-checker-b) 25%, transparent 25%, transparent 75%, var(--color-checker-b) 75%);background-size:var(--size-checker) var(--size-checker);background-position:0 0, calc(var(--size-checker) / 2) calc(var(--size-checker) / 2);}[data-part="lut-thumb"].svelte-j81rnd {width:100%;height:100%;aspect-ratio:1 / 1;object-fit:cover;border:1px solid var(--color-panel-border-strong);}.lut-thumb-crosshair.svelte-j81rnd {position:absolute;inset:0;pointer-events:none;}.lut-thumb-crosshair.svelte-j81rnd::before {position:absolute;content:\'\';left:0;right:0;top:var(--ch-y);height:1px;border-top:1px dashed var(--color-crosshair-dash);background:var(--color-crosshair-shade);}.lut-thumb-crosshair.svelte-j81rnd::after {position:absolute;content:\'\';top:0;bottom:0;left:var(--ch-x);width:1px;border-left:1px dashed var(--color-crosshair-dash);background:var(--color-crosshair-shade);}[data-part="op-grid"].svelte-j81rnd {display:grid;grid-template-columns:repeat(3, minmax(0, 1fr));gap:6px;}[data-part="op-item"].svelte-j81rnd {display:flex;flex-direction:column;gap:3px;}\n\n  @media (max-width: 1180px) {article[data-step-item="true"].svelte-j81rnd {grid-template-columns:7ch minmax(0, 1fr) 90px;hyphens:auto;}\n  }'
};

export default function Svelte_step_row($$anchor, $$props) {
	$.push($$props, true);
	$.append_styles($$anchor, $$css);

	const step = $.prop($$props, 'step', 7),
		stepIndex = $.prop($$props, 'stepIndex', 7),
		luts = $.prop($$props, 'luts', 23, () => []),
		customParams = $.prop($$props, 'customParams', 23, () => []),
		tr = $.prop($$props, 'tr', 7),
		onCaptureScroll = $.prop($$props, 'onCaptureScroll', 7, () => undefined),
		onStepMuteChange = $.prop($$props, 'onStepMuteChange', 7, () => undefined),
		onDuplicateStep = $.prop($$props, 'onDuplicateStep', 7, () => undefined),
		onRemoveStep = $.prop($$props, 'onRemoveStep', 7, () => undefined),
		onStepLabelChange = $.prop($$props, 'onStepLabelChange', 7, () => undefined),
		onStepLutChange = $.prop($$props, 'onStepLutChange', 7, () => undefined),
		onStepBlendModeChange = $.prop($$props, 'onStepBlendModeChange', 7, () => undefined),
		onStepOpChange = $.prop($$props, 'onStepOpChange', 7, () => undefined),
		computeLutUv = $.prop($$props, 'computeLutUv', 7, undefined),
		onStatus = $.prop($$props, 'onStatus', 7, () => undefined);

	let crosshairUv = $.state(null);

	function resolveLut(lutId) {
		return luts().find((item) => item.id === lutId) ?? luts()[0] ?? null;
	}

	function handleLutChange(event) {
		const input = event.currentTarget;

		if (!input) {
			onStatus()(tr()('pipeline.status.stepLutSelectMissing'), 'error');

			return;
		}

		const lutId = input.value;

		if (typeof lutId !== 'string' || lutId.trim().length === 0) {
			onStatus()(tr()('pipeline.status.selectedLutIdInvalid'), 'error');

			return;
		}

		if (!luts().some((lut) => lut.id === lutId)) {
			onStatus()(tr()('pipeline.status.selectedLutMissing'), 'error');

			return;
		}

		onCaptureScroll()();
		onStepLutChange()(step().id, lutId);
	}

	function handleBlendModeChange(event) {
		const input = event.currentTarget;

		if (!input) {
			onStatus()(tr()('pipeline.status.blendModeSelectMissing'), 'error');

			return;
		}

		const blendMode = input.value;

		if (!pipelineModel.isValidBlendMode(blendMode)) {
			onStatus()(tr()('pipeline.status.invalidBlendMode', { blendMode }), 'error');

			return;
		}

		onCaptureScroll()();
		onStepBlendModeChange()(step().id, blendMode);
	}

	function handleOpChange(channel, event) {
		const input = event.currentTarget;

		if (!input) {
			onStatus()(tr()('pipeline.status.stepOpSelectMissing'), 'error');

			return;
		}

		const op = input.value;

		if (!pipelineModel.isValidBlendOp(op)) {
			onStatus()(tr()('pipeline.status.invalidOp', { op }), 'error');

			return;
		}

		onCaptureScroll()();
		onStepOpChange()(step().id, channel, op);
	}

	var $$exports = {
		get step() {
			return step();
		},

		set step($$value) {
			step($$value);
			$.flush();
		},

		get stepIndex() {
			return stepIndex();
		},

		set stepIndex($$value) {
			stepIndex($$value);
			$.flush();
		},

		get luts() {
			return luts();
		},

		set luts($$value = []) {
			luts($$value);
			$.flush();
		},

		get customParams() {
			return customParams();
		},

		set customParams($$value = []) {
			customParams($$value);
			$.flush();
		},

		get tr() {
			return tr();
		},

		set tr($$value) {
			tr($$value);
			$.flush();
		},

		get onCaptureScroll() {
			return onCaptureScroll();
		},

		set onCaptureScroll($$value = () => undefined) {
			onCaptureScroll($$value);
			$.flush();
		},

		get onStepMuteChange() {
			return onStepMuteChange();
		},

		set onStepMuteChange($$value = () => undefined) {
			onStepMuteChange($$value);
			$.flush();
		},

		get onDuplicateStep() {
			return onDuplicateStep();
		},

		set onDuplicateStep($$value = () => undefined) {
			onDuplicateStep($$value);
			$.flush();
		},

		get onRemoveStep() {
			return onRemoveStep();
		},

		set onRemoveStep($$value = () => undefined) {
			onRemoveStep($$value);
			$.flush();
		},

		get onStepLabelChange() {
			return onStepLabelChange();
		},

		set onStepLabelChange($$value = () => undefined) {
			onStepLabelChange($$value);
			$.flush();
		},

		get onStepLutChange() {
			return onStepLutChange();
		},

		set onStepLutChange($$value = () => undefined) {
			onStepLutChange($$value);
			$.flush();
		},

		get onStepBlendModeChange() {
			return onStepBlendModeChange();
		},

		set onStepBlendModeChange($$value = () => undefined) {
			onStepBlendModeChange($$value);
			$.flush();
		},

		get onStepOpChange() {
			return onStepOpChange();
		},

		set onStepOpChange($$value = () => undefined) {
			onStepOpChange($$value);
			$.flush();
		},

		get computeLutUv() {
			return computeLutUv();
		},

		set computeLutUv($$value = undefined) {
			computeLutUv($$value);
			$.flush();
		},

		get onStatus() {
			return onStatus();
		},

		set onStatus($$value = () => undefined) {
			onStatus($$value);
			$.flush();
		}
	};

	var article = root_4();
	var node = $.child(article);

	StepHeader(node, {
		get step() {
			return step();
		},

		get stepIndex() {
			return stepIndex();
		},

		get tr() {
			return tr();
		},

		get onCaptureScroll() {
			return onCaptureScroll();
		},

		get onStepMuteChange() {
			return onStepMuteChange();
		},

		get onDuplicateStep() {
			return onDuplicateStep();
		},

		get onRemoveStep() {
			return onRemoveStep();
		},

		get onStepLabelChange() {
			return onStepLabelChange();
		},

		get onStatus() {
			return onStatus();
		}
	});

	var aside = $.sibling(node, 2);
	var button = $.child(aside);
	var span = $.sibling($.child(button), 4);
	var text = $.only_child(span, true);

	$.reset(button);

	var button_1 = $.sibling(button, 2);
	var span_1 = $.sibling($.child(button_1), 4);
	var text_1 = $.only_child(span_1, true);

	$.reset(button_1);
	$.reset(aside);

	var section = $.sibling(aside, 2);
	var div = $.child(section);
	var label = $.child(div);
	var span_2 = $.child(label);
	var text_2 = $.only_child(span_2, true);
	var select = $.sibling(span_2, 2);

	$.each(select, 21, luts, (lutOpt) => lutOpt.id, ($$anchor, lutOpt) => {
		var option = root();
		var text_3 = $.only_child(option, true);
		var option_value = {};

		$.template_effect(() => {
			$.set_selected(option, $.get(lutOpt).id === step().lutId);
			$.set_text(text_3, $.get(lutOpt).name);

			if (option_value !== (option_value = $.get(lutOpt).id)) {
				option.value = (option.__value = option_value) ?? '';
			}
		});

		$.append($$anchor, option);
	});

	$.reset(select);
	$.reset(label);

	var div_1 = $.sibling(label, 2);
	var img = $.child(div_1);
	var node_1 = $.sibling(img, 2);

	{
		var consequent = ($$anchor) => {
			var div_2 = root_1();

			$.template_effect(() => $.set_style(div_2, `--ch-x: ${$.get(crosshairUv).u * 100}%; --ch-y: ${$.get(crosshairUv).v * 100}%`));
			$.append($$anchor, div_2);
		};

		$.if(node_1, ($$render) => {
			if ($.get(crosshairUv)) $$render(consequent);
		});
	}

	$.reset(div_1);
	$.reset(div);

	var div_3 = $.sibling(div, 2);
	var label_1 = $.child(div_3);
	var span_3 = $.child(label_1);
	var text_4 = $.only_child(span_3, true);
	var select_1 = $.sibling(span_3, 2);

	$.each(select_1, 21, () => BLEND_MODES, (mode) => mode.key, ($$anchor, mode) => {
		var option_1 = root();
		var text_5 = $.only_child(option_1, true);
		var option_1_value = {};

		$.template_effect(() => {
			$.set_text(text_5, $.get(mode).label);

			if (option_1_value !== (option_1_value = $.get(mode).key)) {
				option_1.value = (option_1.__value = option_1_value) ?? '';
			}
		});

		$.append($$anchor, option_1);
	});

	$.reset(select_1);

	var select_1_value;

	$.init_select(select_1);
	$.reset(label_1);
	$.reset(div_3);

	var node_2 = $.sibling(div_3, 2);

	{
		var consequent_1 = ($$anchor) => {
			var div_4 = root_3();

			$.each(div_4, 20, () => getCustomChannelsForBlendMode(step().blendMode), (channel) => channel, ($$anchor, channel) => {
				var label_2 = root_2();
				var span_4 = $.child(label_2);
				var text_6 = $.only_child(span_4, true);
				var select_2 = $.sibling(span_4, 2);

				$.each(select_2, 20, () => getSelectableBlendOpsForChannel(step().blendMode), (op) => op, ($$anchor, op) => {
					var option_2 = root();
					var text_7 = $.only_child(option_2, true);
					var option_2_value = {};

					$.template_effect(() => {
						$.set_text(text_7, op);

						if (option_2_value !== (option_2_value = op)) {
							option_2.value = (option_2.__value = option_2_value) ?? '';
						}
					});

					$.append($$anchor, option_2);
				});

				$.reset(select_2);

				var select_2_value;

				$.init_select(select_2);
				$.reset(label_2);

				$.template_effect(
					($0) => {
						$.set_text(text_6, $0);
						$.set_attribute(select_2, 'data-step-id', step().id);
						$.set_attribute(select_2, 'data-channel', channel);

						if (select_2_value !== (select_2_value = step().ops[channel])) {
							(
								select_2.value = (select_2.__value = select_2_value) ?? '',
								$.select_option(select_2, select_2_value)
							);
						}
					},
					[() => channel.toUpperCase()]
				);

				$.delegated('change', select_2, (event) => handleOpChange(channel, event));
				$.append($$anchor, label_2);
			});

			$.reset(div_4);
			$.append($$anchor, div_4);
		};

		var d = $.derived(() => getCustomChannelsForBlendMode(step().blendMode).length > 0);

		$.if(node_2, ($$render) => {
			if ($.get(d)) $$render(consequent_1);
		});
	}

	$.reset(section);

	var node_3 = $.sibling(section, 2);

	{
		let $0 = $.derived(() => tr()('pipeline.step.previewAria', { index: stepIndex() + 1 }));

		StepPreview(node_3, {
			get stepId() {
				return step().id;
			},

			get stepIndex() {
				return stepIndex();
			},

			get ariaLabel() {
				return $.get($0);
			},

			get computeLutUv() {
				return computeLutUv();
			},

			onCrosshairUvChange: (uv) => {
				$.set(crosshairUv, uv, true);
			}
		});
	}

	$.reset(article);

	$.template_effect(
		($0, $1, $2, $3, $4, $5, $6) => {
			$.set_attribute(article, 'data-step-id', step().id);
			$.set_attribute(article, 'data-muted', step().muted ? 'true' : undefined);
			$.set_attribute(button, 'data-step-id', step().id);
			$.set_attribute(button, 'title', $0);
			$.set_text(text, $1);
			$.set_attribute(button_1, 'data-step-id', step().id);
			$.set_attribute(button_1, 'title', $2);
			$.set_text(text_1, $3);
			$.set_text(text_2, $4);
			$.set_attribute(select, 'data-step-id', step().id);
			$.set_attribute(img, 'src', $5);
			$.set_text(text_4, $6);
			$.set_attribute(select_1, 'data-step-id', step().id);

			if (select_1_value !== (select_1_value = step().blendMode)) {
				(
					select_1.value = (select_1.__value = select_1_value) ?? '',
					$.select_option(select_1, select_1_value)
				);
			}
		},
		[
			() => `X: ${pipelineModel.getParamLabel(step().xParam, customParams())}`,
			() => pipelineModel.getParamLabel(step().xParam, customParams()),
			() => `Y: ${pipelineModel.getParamLabel(step().yParam, customParams())}`,
			() => pipelineModel.getParamLabel(step().yParam, customParams()),
			() => tr()('pipeline.step.lut'),
			() => resolveLut(step().lutId)?.thumbUrl ?? '',
			() => tr()('pipeline.step.blendMode')
		]
	);

	$.delegated('change', select, handleLutChange);
	$.delegated('change', select_1, handleBlendModeChange);
	$.append($$anchor, article);

	return $.pop($$exports);
}

$.delegate(['change']);

$.create_custom_element(
	Svelte_step_row,
	{
		step: {},
		stepIndex: {},
		luts: {},
		customParams: {},
		tr: {},
		onCaptureScroll: {},
		onStepMuteChange: {},
		onDuplicateStep: {},
		onRemoveStep: {},
		onStepLabelChange: {},
		onStepLutChange: {},
		onStepBlendModeChange: {},
		onStepOpChange: {},
		computeLutUv: {},
		onStatus: {}
	},
	[],
	[],
	{ mode: 'open' }
);